export class EquipmentModel {
  modelId: number;
  modelName: string;
  categoryId: number;
  typeId: number;
  typeName: string;
  manufacturerId: number;

  public static constructFromObjectJson(objectJson: any): EquipmentModel {
    const equipmentModel: EquipmentModel = Object.assign(new EquipmentModel(), objectJson);
    return equipmentModel;
  }

  public static constructEquipmentModel(modelId: number, modelName: string): EquipmentModel {
    const equipmentModel: EquipmentModel = new EquipmentModel();
    equipmentModel.modelId = modelId;
    equipmentModel.modelName = modelName;
    return equipmentModel;
  }
}
